import { Grid, Box } from "@mui/material"

function Ready() {
    return(
        <Grid
            container
            height='100vh'
            width='100%'
            display='flex'
            direction='colunm'
            justifyContent='center'
            alignContent='center'>
            <img src="/img/ready.jpg" />
            <Box
                sx={{
                    fontSize: '30px'
                }}>
                서비스 준비중입니다.
            </Box>
        </Grid>
    )
}

export default Ready;